import { render } from "./cloudian.svg?vue&type=template&id=0c28b267?inline"
const script = {}

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__